import React from "react";
import useAppState from "../StateMachine/useAppState";

const mustBeLoggedIn = Component => {
  return () => {
    const route = useAppState("router");
    const accountState = useAppState("account").state;

    if (accountState.isLoggedIn === false) {
      route.push("/user/login");
      return null;
    }

    return (
      <React.Fragment>
        <Component />
      </React.Fragment>
    );
  };
};

export default mustBeLoggedIn;
